import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class VerificationModalService {
  isOpen = false;

  openModal() {
    this.isOpen = true;
  }

  closeModal() {
    this.isOpen = false;
  }
} 